<wire-loader></wire-loader>

<div class="global-wrapper">
  <wire-sidebar class="sidebar"></wire-sidebar>
  <div class="app-container">
    <!-- Desktop video -->
    <!-- <video
      autoplay="autoplay"
      playsinline="true"
      loop
      muted
      class="video-desktop"
    >
      <source
        src="assets/web-video.mp4"
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video> -->

    <!-- Mobile video -->
    <!-- <video
      autoplay="autoplay"
      playsinline="true"
      loop
      muted
      class="video-mobile"
    >
      <source
        src="assets/mobile-video.mp4"
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video> -->

    <wire-header></wire-header>
    <!-- <wire-toaster></wire-toaster> -->

    <div class="content-wrapper">
      <router-outlet />
    </div>
    <wire-footer></wire-footer>
  </div>
</div>
